import React from "react";
import styled from "styled-components";
import moment from "moment";
const Wrapper = styled.span`
  display: flex;
  font-size: ${_ref => {
  let {
    $scale,
    theme
  } = _ref;
  return $scale * theme.typography.fontStep;
}}rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.shape.borderRadius.primary;
}};
  min-width: ${_ref3 => {
  let {
    $scale
  } = _ref3;
  return $scale;
}}rem;
  max-width: ${_ref4 => {
  let {
    $scale
  } = _ref4;
  return $scale;
}}rem;
  min-height: ${_ref5 => {
  let {
    $scale
  } = _ref5;
  return $scale;
}}rem;
  max-height: ${_ref6 => {
  let {
    $scale
  } = _ref6;
  return $scale;
}}rem;
  ${_ref7 => {
  let {
    $s,
    theme
  } = _ref7;
  return theme.spacing.resolve(theme, $s);
}};
  background: transparent;
  border: 3px solid ${_ref8 => {
  let {
    $color
  } = _ref8;
  return $color;
}};
  color: ${_ref9 => {
  let {
    $color
  } = _ref9;
  return $color;
}};
`;
const Day = styled.i`
  font-size: 2em;
  line-height: 1em;
  font-style: normal;
  display: block;
  font-weight: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.typography.fontWeight.semiBold;
}};
`;
const Month = styled.i`
  font-style: normal;
  font-size: 9px;
  line-height: 1em;
  font-weight: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.typography.fontWeight.semiBold;
}};
`;
const DateBadge = _ref12 => {
  let {
    date,
    scale = 4,
    color = "#75a0ef",
    s
  } = _ref12;
  const month = moment(date).format("MMM");
  const day = moment(date).format("D");
  return /*#__PURE__*/React.createElement(Wrapper, {
    $color: color,
    $scale: scale,
    $s: s
  }, /*#__PURE__*/React.createElement(Month, null, month), /*#__PURE__*/React.createElement(Day, null, day));
};
export default DateBadge;